import { createSlice } from '@reduxjs/toolkit'

import { sessionRejected } from '../../../platform/auth/session-events'
import type { SessionState } from '../domain/session'

const initialState: SessionState = {
  status: 'unknown',
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    sessionBecameAnonymous: () => ({ status: 'anonymous' }) as const,
    sessionBecameAuthenticated: () => ({ status: 'authenticated' }) as const,
  },
  extraReducers: (builder) => {
    builder.addCase(sessionRejected, () => ({ status: 'anonymous' }) as const)
  },
})

export const { sessionBecameAnonymous, sessionBecameAuthenticated } =
  sessionSlice.actions
export const sessionReducer = sessionSlice.reducer

export const selectSessionStatus = (state: { session: SessionState }) =>
  state.session.status
